import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeDev from '../views/HomeDev.vue'
import HomeM from '../views/HomeM.vue'
import DetailOrderWompi from '../views/DetailOrderWompi.vue'
import DetailOrderWompiV2 from '../views/DetailOrderWompiV2.vue'
import Question from '../views/Questions.vue'
import Terminos from '../views/Terminos.vue'
import Politicas from '../views/Politicas.vue'
import Ecommerce from '../views/Ecommerce.vue'
import InternaCategory from '../views/InternaCategory.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Cart from '../views/Cart.vue'
import Checkout from '../views/Checkout.vue'
import sidebar from '../views/sidebar.vue'
import OrderDetail from '../views/OrderDetail.vue'
import Gift from '../views/Gift.vue'
import OrderTracking from '../views/OrderTracking.vue'
import WompiRedirect from '../views/WompiRedirect.vue'
import RestaurantCheckout from '../views/RestaurantCheckout.vue'
import Mensajeria from '../views/Mensajeria.vue'
import MensajeriaCheckout from '../views/MensajeriaCheckout.vue';
import DeliveryApp from '../views/DeliveryApp.vue';
import Schedule from '../views/Schedule.vue';
import Linktree from '../views/Linktree.vue';
import QrSurvey from '../views/QrSurvey.vue';
import WayToPay from '../views/WayToPay.vue';
Vue.use(VueRouter)

  const routes = [
    //cambiar para build a 'Home' y quitar 'HomeDev'
  {
    path: '/:id/:mesa?',
    name: 'Home',    
    component: HomeM
  },
  {
    path: '/:id/order/:id_order',
    name: 'DetailOrderWompi',    
    component: DetailOrderWompiV2
  },
  {
    path: '/:id/order-v2/:id_order',
    name: 'DetailOrderWompiV2',    
    component: DetailOrderWompiV2
  },
  {
    path: '/redirect/checkout/:reference/',
    name: 'WompiRedirect',    
    component: WompiRedirect
  },
  {
    path: '/questions/complete/:id_client',
    name: 'Question',    
    component: Question
  },
  {
    path: '/terminos/:name/:id_companie',
    name: 'Terminos',    
    component: Terminos
  },
  {
    path: '/politicas/:name/:id_companie',
    name: 'Politicas',    
    component: Politicas
  },
  {
    path: '/order-tracking/store/:id',
    name: 'OrderTracking',    
    component: OrderTracking
  },
  {
    path: '/delivery-app/store/:id',
    name: 'DeliveryApp',    
    component: DeliveryApp
  },
  {
    path: '/gift/store/:id',
    name: 'Gift',    
    component: Gift
  },
  {
    path: '/sidebar/store/:id',
    name: 'sidebar',    
    component: sidebar
  },
  {
    path: '/OrderDetail/store/:id',
    name: 'OrderDetail',    
    component: OrderDetail
  },
  {
    path: '/RestaurantCheckout/store/:id',
    name: 'RestaurantCheckout',    
    component: RestaurantCheckout
  },
  {
    path: '/Mensajeria/store/:id',
    name: 'Mensajeria',    
    component: Mensajeria
  },
  {
    path: '/MensajeriaCheckout/store/:id',
    name: 'MensajeriaCheckout',    
    component: MensajeriaCheckout
  },
  {
    path: '/way-to-pay/store/:id',
    name: 'WayToPay',    
    component: WayToPay
  },
  {
    path: '/:id/reservation',
    name: 'Schedule',    
    component: Schedule
  },
  {
    path: '/:id/home',
    name: 'Linktree',    
    component: Linktree
  },
  {
    path: '/qr/questions/:id',
    name: 'QrSurvey',    
    component: QrSurvey
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
